<!-- 审批流程总页面 -->
<template>
  <div class="app-container approvalProcess">
    <div class="top-search">
      <header class="search-title">
        <span class="title-text">审批流程</span>
      </header>
      <div class="search-condition">
        <el-form ref="form" :model="searchForm" label-width="95px">
          <el-row :gutter="20">
            <el-col :span="5">
              <el-form-item label="审批名称：">
                <el-input
                  v-model="searchForm.FApprovalName"
                  placeholder="请输入审批名称"
                />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="发起账号：">
                <el-input
                  v-model="searchForm.FApplyAcountNames"
                  placeholder="请输入发起账号"
                  clearable
                  @clear="() => {
                    searchForm.FApplyAcountNames = searchForm.FApplyAcount = ''
                  }"
                >
                  <i
                    slot="suffix"
                    class="el-icon-menu"
                    @click="selectAccountNumber(true)"
                  />
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="审批账号：">
                <el-input
                  v-model="searchForm.FApprovalAcount"
                  placeholder="请输入审批账号"
                />
              </el-form-item>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="currentPage = 1, onSearch()">
                查询
              </el-button>
              <el-button v-if="rols('新增')" style="width:130px;float:right;" @click="addNewProcess(1)">
                <i class="el-icon-circle-plus-outline">
                  新增审批
                </i>
              </el-button>
            </el-col>
          </el-row>

        </el-form>
      </div>
      <!--下方表格-->
      <div class="process-bottom-table">
        <el-table
          ref="multipleTable"
          v-loading="loading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          fit
          :header-cell-style="{background:'#F2F2F8 ',color:'#797E8D',fontSize:'14px',height:'36px'}"
          :row-style="{fontSize:'16px'}"
        >
          <!-- :row-style="{height:'53px'}" -->
          <!-- :cell-style="{ textAlign: 'left' }" -->
          <el-table-column
            label="序号"
            type="index"
            width="90"
            align="center"
          />
          <el-table-column label="审批名称" prop="FApprovalName" show-overflow-tooltip width="150" />
          <el-table-column prop="FUserName" label="发起账号" show-overflow-tooltip width="200" />
          <el-table-column prop="fname" label="审批流程" show-overflow-tooltip>
            <template slot-scope="scope">
              <div class="approval-box" style="display:flex;">
                <div v-for="(t,i) in scope.row.FDetailList" :key="i" class="process-list">
                  <svg-icon v-if="i != 0" :icon-class="processArr[i].svgClass" />
                  <div :style="processArr[i].style" class="process-box">
                    <div class="process-title">
                      {{ processArr[i].text }}
                    </div>
                    <div class="process-content">
                      <div class="process-text">
                        {{ t.FApprovalUserName }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <div class="bottom-operation">
                <span v-if="rols('查看')" @click="addNewProcess(3,scope.row)">
                  查看
                </span>
                <span v-if="rols('修改')" @click="addNewProcess(2,scope.row)">
                  修改
                </span>
                <span v-if="rols('删除')" @click="dltProcess(scope.row)">
                  删除
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          :current-page="currentPage"
          :page-sizes="[10,50, 100, 500]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
    <addProcess :edit-process="editProcess" :title="title" :add-visible="addVisible" @onSearch="onSearch" @addSwitch="addSwitch" />
    <tips :tips-visible="tipsVisible" :tips-data="tipsData" @tipsSwitch="tipsSwitch" />
    <searchDia
      v-if="searchVisible"
      ref="search"
      :is-checkout-box="true"
      :search-visible="searchVisible"
      @cfmSearch="cfmSearch"
      @closeSearch="selectAccountNumber(false)"
    />
  </div>
</template>

<script>
import service from '@/utils/request'
import addProcess from './addProcess.vue'
import tips from '@/components/small-tips'
import searchDia from './accountNumber.vue'
export default {
  components: {
    addProcess,
    tips,
    searchDia
  },
  data() {
    return {
      searchVisible: false,
      editProcess: null,
      loading: false,
      currentPage: 1,
      pageSize: 50,
      total: 0,
      tipsVisible: false,
      tipsData: {
        title: '删除',
        svgClass: 'depart-delete',
        text: '确认删除该审批流吗？'
      },
      title: '',
      addVisible: false,
      processArr: [
        {
          text: '一级审批',
          svgClass: '',
          style: 'background:#F66666;'
        },
        {
          text: '二级审批',
          svgClass: 'first-line',
          style: 'background:#F6A066;'
        },
        {
          text: '三级审批',
          svgClass: 'second-line',
          style: 'background:#42DFBA;'
        },
        {
          text: '四级审批',
          svgClass: 'thired-line',
          style: 'background:#6692F6;'
        },
        {
          text: '五级审批',
          svgClass: 'fourth-line',
          style: 'background:#A76DFF;'
        }
      ],
      searchForm: {
        FApprovalName: '',
        FApplyAcount: '',
        FApplyAcountNames: '',
        FApprovalAcount: ''
      },
      tableData: [],
      selectRow: null
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('审批设置')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  created() {
    this.onSearch()
  },
  methods: {
    cfmSearch(val) {
      const ids = []
      const names = []
      val.forEach(t => {
        ids.push(t.FID)
        names.push(t.FUserName)
      })
      this.searchForm.FApplyAcountNames = names.toString()
      this.searchForm.FApplyAcount = ids.toString()
      this.selectAccountNumber(false)
    },
    selectAccountNumber(val) {
      this.searchVisible = val
    },
    onSearch() {
      this.loading = true
      const jsonobj = JSON.parse(JSON.stringify(this.searchForm))
      delete jsonobj.FApplyAcountNames
      const params = new URLSearchParams()
      params.append('pageNo', this.currentPage)
      params.append('pageSize', this.pageSize)
      params.append('jsonobj', JSON.stringify(jsonobj))
      service({
        url: '/mall/mallmanage/billapprovalPolicy/list',
        method: 'post',
        params
      })
        .then(res => {
          if (!res.data)res.data = { records: [], total: 0 }
          this.tableData = res.data.records
          this.total = res.data.total
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.onSearch()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.onSearch()
    },
    addSwitch() {
      this.addVisible = false
      this.editProcess = null
    },
    addNewProcess(val, row) {
      if (val === 1) {
        this.title = '新增审批'
      } else if (val === 2) {
        this.editProcess = row
        this.title = '修改审批'
      } else {
        this.editProcess = row
        this.title = '查看审批'
      }
      this.addVisible = true
    },
    tipsSwitch(val) {
      if (val) {
        const params = new URLSearchParams()
        params.append('FBillId', this.selectRow.FBillId)
        service({
          url: '/mall/mallmanage/billapprovalPolicy/delBillapproval',
          method: 'post',
          params
        })
          .then(res => {
            if (res.result) {
              this.$message.success(res.msg)
              this.tipsVisible = false
              this.onSearch()
            } else {
              this.$message.error(res.msg)
            }
          })
      } else {
        this.tipsVisible = false
      }
    },
    dltProcess(row) {
      this.selectRow = row
      this.tipsVisible = true
    }
  }

}
</script>

<style lang="scss" scoped>
.app-container {
  background: #ffffff;
  padding: 8px 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .approval-box {
      width: 100%;
      overflow-x: auto;
  }
  // 滚动条
        .approval-box::-webkit-scrollbar {/*滚动条整体样式*/
            width: 10px;     /*高宽分别对应横竖滚动条的尺寸*/
            height: 10px;
        }
        .approval-box::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: #E5E5E5;
        }
        .approval-box::-webkit-scrollbar-track {/*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 10px;
            background: #ffffff;
        }
  .iconBox {
    width: 35px;
    height: 35px;
  }
  .commodity-form {
    display: flex;
    margin: 17px 10px;
    .first-button {
      background-color: #ec212d;
      color: #fff;
    }
  }
  .search-title {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background-color: #ec212d;
    .title-text {
      color: #fff;
      font-size: 20px;
      margin-left: 11px;
    }
  }
  .top-search {
    width: 100%;
    display: flex;
    flex-direction: column;
    .search-condition {
        margin-top: 20px;

        .operation_btn {
            width: 125px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #EC212D;
            color: #EC212D;
        }
    }
    .process-bottom-table {
        .process-list {
            display: flex;
            .svg-icon {
                position: relative;
                top: 16px;
                margin: 0 3px;
                font-size: 30px;
            }
        }
        .process-box {
            width: 153px;
            height: 63px;
            border-radius: 6px;
            background-color: #F66666;
            .process-title {
                height: 23px;
                line-height: 23px;
                font-size: 12px;
                color: #FFFFFF;
                padding: 0 9px;
            }
            .process-content {
                width: 144px;
                height: 36px;
                margin: 0 5px;
                border-radius: 6px;
                background-color: #fff;
                font-size: 14px;
                color: #797E8D;
                display: flex;
                align-items: center;
                padding: 0 3px;

                .process-text {
                    white-space: normal;
                    line-height: 18px;
                    display: -webkit-box;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    word-break: break-all;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;//此处为行数，可以改为任意数字
                }
            }
        }
        .bottom-operation {
            display: flex;
            color: #EC212D;
            span {
                display: inline-block;
                width: 62px;
                cursor: pointer;
                text-align: center;
            }
            span:nth-child(2) {
                border-left: 1px solid #CECFD9;
                border-right: 1px solid #CECFD9;
            }
        }
    }
  }
  .right-table {
    width: 100%;
    height: 100%;
    padding: 0 10px;
    overflow: hidden;
    position: relative;
    .commodity-pagination {
      text-align: center;
      margin-top: 10px;
    }
  }
  .bottom-table {
    height: 88%;
  }
  .operation-icon {
    width: 16px;
    height: 16px;
    margin-right: 15px;
    cursor: pointer;
  }
  .one-icon {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.approvalProcess {
    .el-table__body-wrapper {
       height: 510px;
       overflow-y: auto;
    }
}
.search-condition {
    .el-input__inner {
          height: 40px !important;
      }
    .el-form-item {
                margin-bottom: 20px;
            }
    .el-form-item__label {
        font-size: 16px !important;
        color: #8C909C;
    }
    .el-input__suffix {
        right: 10px;
        line-height: 40px;
    }
    .el-button {
        position: relative;
        width: 77px;
        height: 40px;
        font-size: 18px;
        background: #EC212D;
        border-radius: 4px 4px 4px 4px;
        color: #fff;
        span {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
        }
    }

}
.process-bottom-table {
    .el-pagination {
        display: flex;
        justify-content: right;
        align-items: center;
        height: 65px;
    }
}
</style>
